<template>
  <div class="site-page project-page">
    <section class="sub-page-banner project-banner">
      <div class="site-container">
        <div class="banner-inner">
          <div class="page-breadcrumb">
            <span @click="$router.push('/home')">首页</span>
            <span class="sep">&gt;</span>
            <span @click="$router.push('/visa')">签证移民</span>
            <span class="sep">&gt;</span>
            <span class="current">{{ project.name }}</span>
          </div>
          <h1>{{ projectType }}</h1>
        </div>
      </div>
    </section>

    <div class="site-container project-content">
      <div class="section-card brief-card">
        <p class="brief-line">{{ project.intro }}</p>
        <div class="info-grid">
          <div class="info-item" v-if="project.period">
            <img src="@/assets/imgs/ysgj_021@2x.png" alt="">
            <span class="label">办理周期：</span>
            <span class="value">{{ project.period }}</span>
          </div>
          <div class="info-item" v-if="project.amount">
            <img src="@/assets/imgs/ysgj_020@2x.png" alt="">
            <span class="label">投资金额：</span>
            <span class="value">{{ project.amount }}</span>
          </div>
          <div class="info-item" v-if="project.english">
            <img src="@/assets/imgs/ysgj_024@2x.png" alt="">
            <span class="label">英文要求：</span>
            <span class="value">{{ project.english }}</span>
          </div>
          <div class="info-item" v-if="project.age">
            <img src="@/assets/imgs/ysgj_023@2x.png" alt="">
            <span class="label">年龄：</span>
            <span class="value">{{ project.age }}</span>
          </div>
          <div class="info-item" v-if="project.identity">
            <img src="@/assets/imgs/ysgj_022@2x.png" alt="">
            <span class="label">所获身份：</span>
            <span class="value">{{ project.identity }}</span>
          </div>
        </div>
      </div>

      <div class="tab-head section-card" ref="navBar">
        <button
          v-for="item in navItems"
          :key="item.key"
          type="button"
          :class="{ active: activeNav === item.key }"
          @click="scrollToSection(item.key)"
        >
          {{ item.label }}
        </button>
      </div>

      <div id="overview" class="section-card content-card">
        <h3>项目概述</h3>
        <div v-if="project.overviewHtml" class="rich-content" v-html="project.overviewHtml"></div>
        <p v-else v-for="paragraph in overviewBlocks" :key="paragraph">{{ paragraph }}</p>
      </div>

      <div id="advantages" v-if="project.advantages && project.advantages.length" class="section-card content-card">
        <h3>项目优势</h3>
        <div class="advantages-list">
          <div v-for="(item, index) in advantagesList" :key="index" class="advantage-item">
            <span class="advantage-dot"></span>
            <div class="advantage-main">
              <p v-if="item.type === 'text'" class="advantage-text">{{ item.text }}</p>
              <div v-else class="advantage-group">
                <p class="advantage-title">{{ item.title }}</p>
                <div class="advantage-ordered">
                  <div v-for="(sub, subIndex) in item.items" :key="subIndex" class="advantage-ordered-item">
                    <span class="order-index">{{ subIndex + 1 }}.</span>
                    <span class="order-text">{{ sub }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="conditions" class="section-card content-card">
        <h3>申请条件</h3>
        <div class="conditions-list">
          <div class="condition-item" v-for="(item, index) in conditionsList" :key="index">
            <span class="condition-num">{{ index + 1 }}</span>
            <div class="condition-body">
              <p class="condition-title" v-if="item.title">{{ item.title }}</p>
              <p v-if="item.content">{{ item.content }}</p>
              <div v-if="item.items && item.items.length" class="condition-subs">
                <p v-for="(sub, idx) in item.items" :key="idx">{{ idx + 1 }}. {{ sub }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="process" class="section-card content-card">
        <h3>申请流程</h3>
        <div class="conditions-list">
          <div class="condition-item" v-for="(item, index) in processSteps" :key="item.step || index">
            <span class="condition-num">{{ index + 1 }}</span>
            <div class="condition-body">
              <p>{{ item.title || item }}</p>
            </div>
          </div>
        </div>
      </div>

      <div id="documents" class="section-card content-card">
        <h3>所需文件</h3>
        <div class="conditions-list">
          <div class="condition-item" v-for="(item, index) in documentsList" :key="item.name || index">
            <span class="condition-num">{{ index + 1 }}</span>
            <div class="condition-body">
              <p>{{ item.name }}</p>
              <p v-if="item.desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="site-container bottom-modules">
      <div class="news-grid">
        <article class="section-card news-col" v-for="col in newsColumns" :key="col.key">
          <header>
            <div class="col-title">
              <img :src="col.icon" alt="">
              <h3>{{ col.title }}</h3>
            </div>
            <router-link :to="newsListRoute(col.key)" class="more-link">
              <span class="arrow-icon">→</span>
            </router-link>
          </header>
          <ul>
            <li v-for="item in col.items.slice(0, 4)" :key="item.id" @click="openNews(item)">
              <span class="txt">{{ item.title }}</span>
            </li>
          </ul>
          <div v-if="col.preview" class="news-preview" @click="openNews(col.preview)">
            <div class="thumb">
              <img :src="col.preview.cover || col.preview.image" alt="">
            </div>
            <div class="meta">
              <p class="title">{{ col.preview.title }}</p>
              <p class="date">{{ col.preview.date }}</p>
            </div>
          </div>
          <ul v-if="col.items.length > 4">
            <li v-for="item in col.items.slice(4)" :key="item.id" @click="openNews(item)">
              <span class="txt">{{ item.title }}</span>
            </li>
          </ul>
        </article>
      </div>
    </div>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询">
      </button>
    </div>
  </div>
</template>

<script>
import { getProjectDetail, getNewsList } from '@/api'
import { buildNewsDetailPath, getProjectById, projectList } from '@/data/siteData'

export default {
  name: 'ProjectDetail',
  data() {
    return {
      activeNav: 'overview',
      projectData: null,
      newsColumns: [],
    }
  },
  created() {
    this.fetchProjectDetail()
    this.fetchBottomModules()
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    project() {
      if (this.projectData) {
        return this.projectData
      }

      const routeProject = getProjectById(this.$route.params.id)
      if (routeProject) {
        return routeProject
      }

      const routeName = this.$route.query.type
      return projectList.find((item) => item.name === routeName) || projectList[0]
    },
    projectType() {
      return this.project.name
    },
    overviewBlocks() {
      const source = Array.isArray(this.project.overviewBlocks) && this.project.overviewBlocks.length
        ? this.project.overviewBlocks
        : Array.isArray(this.project.overview) ? this.project.overview : []

      return source
    },
    advantagesList() {
      if (!Array.isArray(this.project.advantages)) {
        return []
      }

      return this.project.advantages
        .map((item) => {
          if (typeof item === 'string') {
            return { type: 'text', text: item }
          }

          if (!item || typeof item !== 'object') {
            return null
          }

          if (item.type === 'group' || Array.isArray(item.items)) {
            return {
              type: 'group',
              title: item.title || '',
              items: Array.isArray(item.items) ? item.items : [],
            }
          }

          return {
            type: 'text',
            text: item.text || item.content || item.title || '',
          }
        })
        .filter((item) => item && (item.type !== 'text' || String(item.text || '').trim() !== ''))
    },
    conditionsList() {
      if (!Array.isArray(this.project.conditions)) {
        return []
      }

      return this.project.conditions
        .map((item) => {
          if (typeof item === 'string') {
            const match = item.match(/^([^：:]+)[：:]\s*(.+)$/u)
            if (match) {
              return { title: match[1], content: match[2], items: [] }
            }
            return { title: '', content: item, items: [] }
          }

          if (!item || typeof item !== 'object') {
            return null
          }

          return {
            title: item.title || '',
            content: item.content || '',
            items: Array.isArray(item.items) ? item.items : [],
          }
        })
        .filter(Boolean)
    },
    processSteps() {
      if (!Array.isArray(this.project.processSteps) || !this.project.processSteps.length) {
        if (!Array.isArray(this.project.process)) {
          return []
        }

        return this.project.process.map((item, index) =>
          typeof item === 'string' ? { step: index + 1, title: item } : item
        )
      }

      return this.project.processSteps
    },
    documentsList() {
      if (!Array.isArray(this.project.documents)) {
        return []
      }

      return this.project.documents
        .map((item) => {
          if (typeof item === 'string') {
            const [name, ...rest] = item.split('|')
            return { name: String(name || '').trim(), desc: rest.join('|').trim() }
          }

          if (!item || typeof item !== 'object') {
            return null
          }

          return {
            name: item.name || '',
            desc: item.desc || '',
          }
        })
        .filter(Boolean)
    },
    navItems() {
      const items = [
        { key: 'overview', label: '项目概述' },
      ]
      if (this.project.advantages && this.project.advantages.length) {
        items.push({ key: 'advantages', label: '项目优势' })
      }
      items.push(
        { key: 'conditions', label: '申请条件' },
        { key: 'process', label: '申请流程' },
        { key: 'documents', label: '所需文件' }
      )
      return items
    },
  },
  watch: {
    '$route.params.id'() {
      this.fetchProjectDetail()
    },
  },
  methods: {
    async fetchProjectDetail() {
      try {
        const data = await getProjectDetail(this.$route.params.id)
        this.projectData = data && data.id ? data : null
      } catch (error) {
        this.projectData = null
      }
    },
    scrollToSection(key) {
      const el = document.getElementById(key)
      if (el) {
        const offset = 90
        const top = el.getBoundingClientRect().top + window.pageYOffset - offset
        window.scrollTo({ top, behavior: 'smooth' })
      }
    },
    onScroll() {
      const offset = 100
      for (let i = this.navItems.length - 1; i >= 0; i--) {
        const key = this.navItems[i].key
        const el = document.getElementById(key)
        if (el && el.getBoundingClientRect().top <= offset) {
          this.activeNav = key
          return
        }
      }
      this.activeNav = 'overview'
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async fetchBottomModules() {
      try {
        const [bizRes, newsRes, caseRes] = await Promise.all([
          getNewsList({ type: 'biz', limit: 5 }),
          getNewsList({ type: 'news', limit: 5 }),
          getNewsList({ type: 'cases', limit: 5 }),
        ])
        const iconMap = {
          biz: require('@/assets/imgs/ysgj_013@2x.png'),
          news: require('@/assets/imgs/ysgj_014@2x.png'),
          cases: require('@/assets/imgs/ysgj_015@2x.png'),
        }
        const bizItems = Array.isArray(bizRes.list) ? bizRes.list : []
        const newsItems = Array.isArray(newsRes.list) ? newsRes.list : []
        const caseItems = Array.isArray(caseRes.list) ? caseRes.list : []

        this.newsColumns = [
          {
            key: 'biz',
            title: '商业项目',
            icon: iconMap.biz,
            items: bizItems,
            preview: bizItems[0],
          },
          {
            key: 'news',
            title: '资讯中心',
            icon: iconMap.news,
            items: newsItems,
            preview: newsItems[0],
          },
          {
            key: 'cases',
            title: '成功案例',
            icon: iconMap.cases,
            items: caseItems,
            preview: caseItems[0],
          },
        ]
      } catch (e) {
        this.newsColumns = []
      }
    },
    newsListRoute(type) {
      return { path: '/news', query: { tab: type } }
    },
    openNews(item) {
      this.$router.push(buildNewsDetailPath(item.id))
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
  },
}
</script>

<style scoped>
.project-banner {
  background-image: url('~@/assets/imgs/ysgj_044@2x.png');
  background-position: center;
  background-size: cover;
}

.project-content {
  position: relative;
  z-index: 4;
  margin-top: -28px;
  padding-bottom: 40px;
}

.brief-card {
  padding: 20px 28px;
}

.brief-line {
  font-size: 15px;
  line-height: 1.9;
  color: #5a6473;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e7edf5;
}

.banner-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.page-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 0 14px;
  color: #fff;
  font-size: 13px;
}

.page-breadcrumb span {
  cursor: pointer;
}

.page-breadcrumb span.current {
  cursor: default;
  color: rgba(255,255,255,0.75);
}

.page-breadcrumb span.sep {
  cursor: default;
  color: rgba(255,255,255,0.6);
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #4a5463;
}

.info-item img {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.info-item .label {
  color: #8a92a0;
}

.info-item .value {
  color: #2d2f33;
  font-weight: 500;
}

.tab-head {
  margin-top: 16px;
  border-radius: 8px 8px 0 0;
  padding: 0 28px;
  height: 52px;
  display: flex;
  align-items: center;
  gap: 32px;
  background: #e9f3ff;
}

.tab-head button {
  height: 36px;
  border: none;
  border-radius: 0;
  background: transparent;
  color: #4a5463;
  padding: 0 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.tab-head button.active {
  background: transparent;
  color: #315d95;
  font-weight: 700;
}

.tab-head button.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  height: 2px;
  background: var(--site-blue);
}

.content-card {
  margin-top: 16px;
  padding: 24px 28px;
}

.tab-head + .content-card {
  margin-top: 0;
  border-radius: 0 0 8px 8px;
}

.content-card h3 {
  display: flex;
  align-items: center;
  gap: 0;
  font-size: 18px;
  color: #2d2f33;
  margin-bottom: 16px;
  font-weight: 700;
}

.content-card h3::before {
  content: '';
  width: 16px;
  height: 20px;
  background: linear-gradient(180deg, #4a9eff 0%, #165eb4 100%);
  clip-path: polygon(0 0, 100% 50%, 0 100%);
  flex-shrink: 0;
  margin-left: -28px;
  margin-right: 14px;
}

.content-card p {
  font-size: 15px;
  line-height: 2;
  color: #4a5463;
}

.content-card p + p {
  margin-top: 10px;
}

.rich-content :deep(p) {
  font-size: 15px;
  line-height: 2;
  color: #4a5463;
  margin: 0 0 12px;
}

.rich-content :deep(*) {
  max-width: 100%;
}

.rich-content :deep(h1),
.rich-content :deep(h2),
.rich-content :deep(h3),
.rich-content :deep(h4) {
  color: #2d2f33;
  font-weight: 700;
  line-height: 1.6;
}

.rich-content :deep(h1) {
  font-size: 24px;
  margin: 24px 0 14px;
}

.rich-content :deep(h2) {
  font-size: 20px;
  margin: 20px 0 12px;
}

.rich-content :deep(h3) {
  font-size: 17px;
  margin: 18px 0 10px;
}

.rich-content :deep(h4) {
  font-size: 15px;
  margin: 14px 0 8px;
}

.rich-content :deep(img) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 14px auto;
  border-radius: 8px;
}

.rich-content :deep(ul),
.rich-content :deep(ol) {
  margin: 0 0 14px;
  padding-left: 22px;
}

.rich-content :deep(li) {
  margin-bottom: 6px;
  font-size: 15px;
  line-height: 1.95;
  color: #4a5463;
}

.rich-content :deep(a) {
  color: #1d5da8;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  word-break: break-word;
  transition: color 0.2s ease;
}

.rich-content :deep(a:hover) {
  color: #0f4b91;
}

.rich-content :deep(strong),
.rich-content :deep(b) {
  color: #33445b;
  font-weight: 700;
}

.rich-content :deep(blockquote) {
  margin: 16px 0;
  padding: 14px 16px;
  border-left: 4px solid #1d5da8;
  border-radius: 0 8px 8px 0;
  background: #f4f8fc;
  color: #506175;
}

.rich-content :deep(hr) {
  border: none;
  border-top: 1px solid #e5edf5;
  margin: 20px 0;
}

.rich-content :deep(table) {
  width: 100%;
  margin: 14px 0;
  border-collapse: collapse;
  border-spacing: 0;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #e2eaf2 inset;
  display: block;
  overflow-x: auto;
}

.rich-content :deep(table tbody),
.rich-content :deep(table thead) {
  width: 100%;
}

.rich-content :deep(th),
.rich-content :deep(td) {
  min-width: 120px;
  padding: 10px 12px;
  border: 1px solid #e2eaf2;
  text-align: left;
  vertical-align: top;
  font-size: 13px;
  line-height: 1.8;
  color: #576172;
  background: #fff;
}

.rich-content :deep(th) {
  background: #f6f9fc;
  color: #3f536b;
  font-weight: 700;
}

.rich-content :deep(pre) {
  margin: 14px 0;
  padding: 14px 16px;
  border-radius: 10px;
  background: #1f2937;
  color: #f8fafc;
  line-height: 1.75;
  overflow-x: auto;
  font-size: 13px;
}

.rich-content :deep(code) {
  padding: 2px 6px;
  border-radius: 6px;
  background: #f3f6fa;
  color: #28507f;
  font-size: 13px;
}

.rich-content :deep(pre code) {
  padding: 0;
  background: transparent;
  color: inherit;
}

.advantages-list {
  display: grid;
  gap: 10px;
}

.advantage-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.advantage-dot {
  width: 6px;
  height: 6px;
  margin-top: 11px;
  border-radius: 50%;
  background: #4a5463;
  flex-shrink: 0;
}

.advantage-main {
  flex: 1;
  min-width: 0;
}

.advantage-text,
.advantage-title {
  font-size: 14px;
  line-height: 1.95;
  margin: 0;
}

.advantage-group {
  padding: 4px 0;
}

.advantage-title {
  color: #4a5463;
  font-weight: 500;
  margin-bottom: 4px;
}

.advantage-text {
  color: #4a5463;
}

.advantage-ordered {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 10px;
}

.advantage-ordered-item {
  display: flex;
  align-items: flex-start;
  gap: 2px;
  font-size: 14px;
  line-height: 1.95;
  color: #4a5463;
}

.order-index {
  flex: 0 0 auto;
  min-width: 12px;
  color: #4a5463;
  font-weight: 500;
  text-align: right;
}

.order-text {
  flex: 1;
  min-width: 0;
  color: inherit;
}

.content-card ul {
  padding-left: 0;
  list-style: none;
}

.content-card ul li {
  position: relative;
  padding-left: 16px;
  font-size: 15px;
  line-height: 2;
  color: #4a5463;
  margin-bottom: 6px;
}

.content-card ul li::before {
  content: '•';
  position: absolute;
  left: 0;
  top: 0;
  color: var(--site-blue);
  font-size: 14px;
  font-weight: 700;
}

.conditions-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.condition-item {
  display: flex;
  gap: 12px;
}

.condition-num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #0a51a1;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.condition-body {
  flex: 1;
  font-size: 15px;
  line-height: 1.9;
  color: #4a5463;
}

.condition-title {
  font-weight: 700;
  color: #2d2f33;
  margin-bottom: 4px;
}

.condition-subs {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.condition-subs p {
  font-size: 14px;
  line-height: 1.85;
  color: #4a5463;
}



.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}

.bottom-modules {
  padding: 16px 0 40px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.news-col {
  padding: 20px;
  box-shadow: none;
  border: 1px solid #f0f2f5;
}

.news-col header {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf1f6;
  margin-bottom: 10px;
}

.col-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.col-title img {
  width: 36px;
  height: 36px;
}

.col-title h3 {
  font-size: 17px;
  color: #2d2f33;
  font-weight: 700;
}

.more-link {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--site-blue);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
}

.arrow-icon {
  display: block;
  line-height: 1;
  transform: translateX(-1px);
}

.news-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.news-col ul li {
  height: 42px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.news-col ul li .txt {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #4a5463;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-col ul li:hover .txt {
  color: var(--site-blue);
}

.news-preview {
  margin: 8px 0;
  border-radius: 8px;
  padding: 10px;
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 10px;
  cursor: pointer;
}

.news-preview .thumb {
  height: 64px;
  border-radius: 6px;
  overflow: hidden;
}

.news-preview .thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-preview .title {
  font-size: 12px;
  line-height: 1.5;
  color: #4d5a70;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-preview .date {
  margin-top: 4px;
  font-size: 12px;
  color: #9aa3b1;
}

</style>
